export type {
  ReceiptWidthMm,
  SaleReceiptDocument,
  SaleReceiptLine,
  SaleReceiptPayload,
  SaleReceiptPayment,
  ThermalPrintDocument,
} from './types';
export type {
  FiscalReceiptDocument,
  FiscalReceiptLine,
  FiscalReceiptPayload,
} from './fiscalTypes';
export {
  buildFiscalComprobante,
  renderFiscalComprobanteEscPos,
  formatComprobanteNumber,
  formatFiscalCuit,
} from './buildFiscalComprobante';
export { buildSaleReceipt, renderSaleReceiptEscPos } from './buildSaleReceipt';
export { encodeEscPosPlainText } from './escposPlainText';
export { formatReceiptMoney, formatReceiptWhen, escapeReceiptHtml } from './format';
export { wrapThermalHtml, thermalHtmlStyles } from './renderThermalHtml';
